import { IImage } from './image.model';
import { IPaymentMethod, PaymentMethod } from "./payment-method.model";

export interface IMovement {
  idMovement: string;
  idCompany: string;
  idBranch?: string;
  description: string;
  notes: string;
  amount: string;
  movementType: boolean;
  status: boolean;
  idPaymentMethod?: string;
  bankReference?: string;
  invoice?: boolean;
  idTicket?: string;
  idInvoicePdf?: string;
  idInvoiceXml?: string;
  ticket?: IImage | null;
  invoicePdf?: IImage | null;
  invoiceXml?: IImage | null;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: string;
  updatedAt: string;
  paymentMethod?: IPaymentMethod;
}

export class Movement {
  idMovement: string;
  idCompany: string;
  idBranch?: string;
  description: string;
  notes: string;
  amount: string;
  movementType: boolean;
  status: boolean;
  idPaymentMethod?: string;
  bankReference?: string;
  invoice?: boolean;
  idTicket?: string;
  idInvoicePdf?: string;
  idInvoiceXml?: string;
  ticket?: IImage | null;
  invoicePdf?: IImage | null;
  invoiceXml?: IImage | null;
  uidCreatedBy?: string;
  uidUpdatedBy?: string;
  createdAt: string;
  updatedAt: string;
  paymentMethod?: PaymentMethod;

  constructor(data: IMovement) {
    this.idMovement = data.idMovement;
    this.idCompany = data.idCompany;
    this.idBranch = data.idBranch;
    this.description = data.description;
    this.notes = data.notes;
    this.amount = data.amount;
    this.movementType = data.movementType;
    this.idPaymentMethod = data.idPaymentMethod;
    this.bankReference = data.bankReference;
    this.invoice = data.invoice;
    this.status = data.status;
    this.idTicket = data.idTicket;
    this.idInvoicePdf = data.idInvoicePdf;
    this.idInvoiceXml = data.idInvoiceXml;
    this.ticket = data.ticket;
    this.invoicePdf = data.invoicePdf;
    this.invoiceXml = data.invoiceXml;
    this.uidCreatedBy = data.uidCreatedBy;
    this.uidUpdatedBy = data.uidUpdatedBy;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
    this.paymentMethod = data.paymentMethod
      ? new PaymentMethod(
          data.paymentMethod
        )
      : undefined;
  }

  get movementTypeDescription(): string {
    return this.movementType ? 'Ingreso' : 'Gasto';
  }

  get statusDescription(): string {
    let value: string = '';

    if(this.movementType) {

      if(this.status) {
        value = 'Cobrado';
      } else {
        value = 'Pendiente';
      }

    } else {

      if(this.status) {
        value = 'Pagado';
      } else {
        value = 'Pendiente';
      }

    }

    return value;
  }
}
